import * as React from 'react'
import type { UploadInvalid } from './Upload'
import type { SupportedLanguage } from '../../../shared/i18n/i18n.no-deps'
import { getDisplayFileSize } from '../util/fileSize'
import { arrayToReadableList } from '../util/string'
import { never } from '../util/never'
import { Trans } from 'react-i18next'
import type { TFunction } from 'i18next'

interface Props {
    upload: UploadInvalid
    language: SupportedLanguage
    TFixed: (lng: string | readonly string[], ns?: string | readonly string[], keyPrefix?: string) => TFunction
}
export function InvalidUploadErrorMessage({ upload, language, TFixed }: Props) {
    switch (upload.reason.type) {
        case 'FileTooBig':
            return (
                <div>
                    <Trans i18nKey="appcore:IvalidUploadErrorMessage.fileTooBig">
                        <b>{{ limit: getDisplayFileSize(upload.reason.limit) }}</b>
                    </Trans>
                </div>
            )
        case 'InvalidExtension':
            return (
                <div>
                    <Trans i18nKey="appcore:IvalidUploadErrorMessage.invalidExtension">
                        <b>{{ formats: arrayToReadableList(upload.reason.validExtensions, TFixed, language) }}</b>
                    </Trans>
                </div>
            )
        default:
            never(upload.reason)
    }
}
